module.exports = __webpack_public_path__ + "static/gold-gin-2bc50167e365b08415cfd409ee1dc735.jpg";